export { FilePreviewModal } from './Detail';
export { default } from './Detail';
